module.exports = __webpack_public_path__ + "img/master_slave.af5893de.png";